import { createRouter, createWebHistory } from "vue-router";
// 首页、自定义首页以及分页面
import { scrollBannerAuto } from "@/utils/tools";

import Bus from "@utils/bus.js";
import { noTokenHttp } from "@utils/http"; // 引入请求工具

const routes = [
  {
    path: "/shoppingcart",
    name: "ShoppingCart",
    component: () => import("@views/Personal_copy/ShoppingCart.vue"),
    meta: { title: "购物车 - WidoFactory" },
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@views/Home.vue"),
    meta: { title: "自定义打印 - WidoFactory" },
  },
  {
    path: "/:id?",
    name: "HomeShop",
    component: () => import("@/views/HomeShop/index.vue"),
    meta: { title: "维度工厂 - WidoFactory" },
    // 路由进入前预加载数据
    // async beforeEnter(to, from, next) {
    //   if (from.name) {
    //     try {
    //       // 并行请求所有需要的数据
    //       const [sellRes, hotProductRes, qualityRes, tagRes, authorRes] =
    //         await Promise.all([
    //           noTokenHttp.get(
    //             "/api/user-api/recommend/sellProduct?pageNum=1&pageSize=25",
    //           ),
    //           noTokenHttp.get(
    //             "/api/user-api/recommend/hotProduct?pageNum=1&pageSize=25",
    //           ),
    //           noTokenHttp.get(
    //             "/api/user-api/recommend/qualityProduct?pageNum=1&pageSize=25",
    //           ),
    //           noTokenHttp.get("/api/user-api/tag/list"),
    //           noTokenHttp.get(
    //             "/api/user-api/recommend/saleAuthor?pageNum=1&pageSize=24",
    //           ),
    //         ]);

    //       // 整理预加载数据并存储到路由meta中
    //       to.meta.preloadData = {
    //         sellList: sellRes.data?.rows || [],
    //         hotProductList: hotProductRes.data?.rows || [],
    //         qualityList: qualityRes.data?.rows || [],
    //         hotTags:
    //           tagRes.data.code === 200 ? tagRes.data.data.slice(0, 50) : [],
    //         authorList: authorRes.data.code === 200 ? authorRes.data.rows : [],
    //       };
    //       next();
    //     } catch (error) {
    //       console.error("预加载数据失败:", error);
    //       next();
    //     }
    //   } else {
    //     // 首次打开首页，直接放行，不执行预加载
    //     next();
    //   }
    // },
  },
  {
    path: "/hot",
    name: "HotProd",
    component: () => import("@views/HomeShop/components/HotProd.vue"),
    meta: { title: "热门商品 - WidoFactory" },
  },
  {
    path: "/best",
    name: "BestProd",
    component: () => import("@views/HomeShop/components/BestProd.vue"),
    meta: { title: "最新商品 - WidoFactory" },
  },
  {
    path: "/quality",
    name: "QualityProd",
    component: () => import("@views/HomeShop/components/QualityProd.vue"),
    meta: { title: "优质商品 - WidoFactory" },
  },
  {
    path: "/hottags",
    name: "HotTags",
    component: () => import("@views/HomeShop/components/HotTags.vue"),
    meta: { title: "热门标签 - WidoFactory" },
  },
  {
    path: "/author",
    name: "Author",
    component: () => import("@views/HomeShop/components/SaleAuthor.vue"),
    meta: { title: "优秀创作者 - WidoFactory" },
  },
  {
    path: "/goods/:id",
    name: "Goods",
    component: () => import("@views/Goods.vue"),
    meta: { title: "商品详情 - WidoFactory" },
  },
  {
    path: "/search/:id/:str?",
    name: "SearchResult",
    component: () => import("@views/SearchResult.vue"),
    meta: { title: "搜索结果 - WidoFactory" },
  },
  // {
  //   path: "/test",
  //   name: "test",
  //   component: () => import("@views/test.vue"),
  //   meta: { title: "测试页面 - WidoFactory" },
  // },
  {
    path: "/personal",
    name: "Personal",
    component: () => import("@views/Personal.vue"),
    meta: { title: "个人中心 - WidoFactory" },
  },
  {
    path: "/Collection",
    component: () => import("@views/Collection.vue"),
    meta: { title: "我的收藏 - WidoFactory" },
    children: [{ path: "", name: "Collection", component: () => import("@views/Personal/Collection.vue") }],
  },
  {
    path: "/personalCenter",
    name: "personalCenter",
    component: () => import("@views/personalCenter.vue"),
    // meta: { title: `个人主页 - WidoFactory` },
  },
  {
    path: "/confirmorder",
    name: "ConfirmOrder",
    component: () => import("@views/confirmOrder/ConfirmOrder.vue"),
    meta: { title: "确认订单 - WidoFactory" },
  },
  {
    path: "/editor",
    name: "Editor",
    component: () => import("@views/testEditor.vue"),
    meta: { title: "编辑器 - WidoFactory" },
  },
  {
    path: "/sell",
    component: () => import("@views/Sell/Index.vue"),
    meta: { title: "卖家中心 - WidoFactory" },
    children: [
      {
        path: "",
        name: "Sell",
        component: () => import("@views/Sell/OrderList.vue"),
        meta: { title: "购买记录 - WidoFactory" },
      },
      {
        path: "sellmanager",
        component: () => import("@views/Sell/SellManager.vue"),
        meta: { title: "出售管理 - WidoFactory" },
      },
      {
        path: "billList",
        component: () => import("@views/Sell/BillList.vue"),
        meta: { title: "账单列表 - WidoFactory" },
        children: [
          {
            path: "",
            component: () => import("@views/Sell/components/EarningTable.vue"),
            meta: { title: "收款账单 - WidoFactory" },
          },
          {
            path: "bill",
            name: "bill",
            component: () => import("@views/Sell/components/EarningDetails.vue"),
            meta: { title: "收益详情 - WidoFactory" },
          },
        ],
      },
      {
        path: "deposit",
        component: () => import("@views/Sell/Deposit.vue"),
        meta: { title: "立即提现 - WidoFactory" },
      },
      {
        path: "depositdetails",
        component: () => import("@views/Sell/components/DepositDetails.vue"),
        meta: { title: "提现明细 - WidoFactory" },
      },
      {
        path: "income",
        component: () => import("@views/Sell/IncomeAnalysis.vue"),
        meta: { title: "收益分析 - WidoFactory" },
      },
    ],
  },
  {
    path: "/orderdetails",
    name: "OrderDetails",
    component: () => import("@views/Sell/OrderDetails.vue"),
    meta: { title: "收据详情 - WidoFactory" },
  },
  // {
  //   path: "/receipt",
  //   name: "Receipt",
  //   component: Receipt,
  //   meta: { title: "收据 - WidoFactory" },
  // },
  {
    path: "/addsell",
    name: "AddSell",
    component: () => import("@views/Sell/AddSell.vue"),
    meta: { title: "发布商品 - WidoFactory" },
  },
  {
    path: "/editsell/:id",
    name: "EditSell",
    component: () => import("@views/Sell/AddSell.vue"),
    meta: { title: "编辑商品 - WidoFactory" },
  },
  {
    path: "/comp",
    name: "Comp",
    component: () => import("@/views/Comp/index.vue"),
    meta: { title: "企业中心 - WidoFactory" },
  },
  {
    path: "/about",
    name: "AboutUs",
    component: () => import("@/views/AboutUs/index.vue"),
    meta: { title: "关于我们 - WidoFactory" },
  },
  {
    path: "/join",
    name: "JoinUs",
    component: () => import("@/views/JoinUs/index.vue"),
    meta: { title: "加入我们 - WidoFactory" },
  },
  {
    path: "/help",
    name: "Help",
    component: () => import("@/views/Help/index.vue"),
    meta: { title: "帮助中心 - WidoFactory" },
  },
  {
    path: "/certify",
    name: "Certify",
    component: () => import("@/views/Agreement/components/License.vue"),
    meta: { title: "资质认证 - WidoFactory" },
  },
  {
    path: "/certifys",
    name: "Certifys",
    component: () => import("@/views/Agreement/components/ManageLicense.vue"),
    meta: { title: "资质管理 - WidoFactory" },
  },
  {
    path: "/agreement",
    name: "Agreement",
    component: () => import("@/views/Agreement/Index.vue"),
    meta: { title: "用户协议 - WidoFactory" },
    children: [
      {
        path: "",
        name: "AgreementBuyer",
        component: () =>
          import("@/views/Agreement/components/AgreementBuyer.vue"),
        meta: { title: "买家协议 - WidoFactory" },
      },
      {
        path: "seller",
        name: "AgreementSeller",
        component: () =>
          import("@/views/Agreement/components/AgreementSeller.vue"),
        meta: { title: "卖家协议 - WidoFactory" },
      },
      {
        path: "orginal",
        name: "UserOriginal",
        component: () =>
          import("@/views/Agreement/components/UserOriginal.vue"),
        meta: { title: "用户原创协议 - WidoFactory" },
      },
      {
        path: "privacy",
        name: "WidePrivacy",
        component: () => import("@/views/Agreement/components/WidePrivacy.vue"),
        meta: { title: "隐私政策 - WidoFactory" },
      },
      {
        path: "print",
        name: "Print",
        component: () => import("@/views/Agreement/components/Print.vue"),
        meta: { title: "打印服务协议 - WidoFactory" },
      },
      {
        path: "after",
        name: "After",
        component: () => import("@/views/Agreement/components/After.vue"),
        meta: { title: "售后服务协议 - WidoFactory" },
      },
    ],
  },
  {
    path: "/notfound",
    name: "NotFound",
    component: () => import("@/components/App/404.vue"),
    meta: { title: "页面不存在 - WidoFactory" },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (!to.hash) {
      if (savedPosition) {
        return savedPosition;
      } else {
        Bus.$emit("scrollToTop");
      }
    }
  },
});

const userRouter = ["Personal", "ConfirmOrder"];

const wihteList = [
  "Home",
  "HomeShop",
  "HotProd",
  "BestProd",
  "QualityProd",
  "Author",
  "HotTags",
  "Goods",
  "SearchResult",
  "AboutUs",
  "JoinUs",
  "Help",
  "Certify",
  "Certifys",
  "Agreement",
  "AgreementBuyer",
  "AgreementSeller",
  "UserOriginal",
  "WidePrivacy",
  "Print",
  "After",
  "NotFound",
];

router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "WidoFactory - 每个人都是设计师";
  }

  const isLogin =
    localStorage.getItem("isLogin") || sessionStorage.getItem("isLogin");
  if (!isLogin) {
    if (wihteList.indexOf(to.name) !== -1) {
      next();
    } else {
      next({ name: "HomeShop" });
      Bus.$emit("changeLoginShow", true);
    }
  } else {
    next();
  }
});

export default router;
